import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/contexts/AuthContext";
import { ROLES } from "@/shared/lib/rbac";
import { lapsedModulesOf } from "@/shared/lib/forbiddenReason";
import { myBillingService } from "../api/myBillingService";
import { subscriptionLapse, type SubscriptionLapse } from "../lib/subscriptionLapse";

/**
 * 当前租户套餐是否已到期(1005)。口径见 {@link subscriptionLapse}。
 * 只租户超管去读 /tenant/billing/me(其余角色后端 403);queryKey 与「我的套餐」/ 到期横幅共用缓存。
 */
export function useSubscriptionLapse(): SubscriptionLapse & { lapsedModules: string[] } {
  const { effectiveRole, permissions } = useAuth();
  const isAdmin = effectiveRole === ROLES.TENANT_ADMIN;
  const { data } = useQuery({
    queryKey: ["my", "subscription"],
    queryFn: () => myBillingService.getSubscription(),
    enabled: isAdmin,
    retry: false,
    meta: { suppressGlobalErrorToast: true },
  });
  const lapsedModules = lapsedModulesOf(permissions);
  const openModules = Object.entries(permissions?.modules ?? {})
    .filter(([, p]) => p && p.page !== "none")
    .map(([k]) => k);
  return {
    ...subscriptionLapse({
      adminSubscription: isAdmin ? data : undefined,
      subscriptionStatus: permissions?.subscriptionStatus,
      subscriptionEndAt: permissions?.subscriptionEndAt,
      lapsedModules,
      openModules,
    }),
    lapsedModules,
  };
}
